export var FIELD_ERROR_VIEW;
(function (FIELD_ERROR_VIEW) {
    FIELD_ERROR_VIEW["tooltip"] = "tooltip";
    FIELD_ERROR_VIEW["bottom"] = "bottom";
})(FIELD_ERROR_VIEW || (FIELD_ERROR_VIEW = {}));
export var FIELD_LAYOUT_HELP_TEXT_VIEW;
(function (FIELD_LAYOUT_HELP_TEXT_VIEW) {
    FIELD_LAYOUT_HELP_TEXT_VIEW[FIELD_LAYOUT_HELP_TEXT_VIEW["normal"] = 0] = "normal";
    FIELD_LAYOUT_HELP_TEXT_VIEW[FIELD_LAYOUT_HELP_TEXT_VIEW["labelDescription"] = 1] = "labelDescription";
    FIELD_LAYOUT_HELP_TEXT_VIEW[FIELD_LAYOUT_HELP_TEXT_VIEW["narrowControl"] = 2] = "narrowControl";
})(FIELD_LAYOUT_HELP_TEXT_VIEW || (FIELD_LAYOUT_HELP_TEXT_VIEW = {}));
//# sourceMappingURL=types.js.map